function renderMap(mapContainer) {
	const lat = mapContainer?.dataset?.lat;
	const lng = mapContainer?.dataset?.lng;
	const zoom = mapContainer?.dataset?.zoom;
	const address = mapContainer?.dataset?.address;
	const offset_lat = 0;
	const offset_lng = 0;

	if (
		mapContainer === null
		|| null === lat
		|| null === lng
		|| null === zoom
	) {
		return;
	}

	let offsetApplied = false;
	let latOffset = 0;
	let lngOffset = 0;
	let latLngCenter = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));

	// https://developers.google.com/maps/documentation/javascript/reference/map
	let mapOptions = {
		zoom: parseInt(`${zoom}`), // initialize zoom level - the max value is 21
		streetViewControl: false, // hide the yellow Street View pegman
		scaleControl: true, // allow users to zoom the Google Map
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		center: latLngCenter,
		disableDefaultUI: false,
		keyboardShortcuts: false,
		fullscreenControl: false,
		gestureHandling: "cooperative",
		mapTypeControl: false,
	};

	let map = new google.maps.Map(mapContainer, mapOptions);

	google.maps.event.addListener(map, 'bounds_changed', function () {
		if (offsetApplied === false) {
			const dimensions = googleMapCalculateDimensions(map);
			latOffset = dimensions.height / 100 * parseFloat(offset_lat);
			lngOffset = dimensions.width / 100 * parseFloat(offset_lng);
			latLngCenter = new google.maps.LatLng(parseFloat(lat) + latOffset, parseFloat(lng) + lngOffset);
			map.setCenter(latLngCenter);
			offsetApplied = true;
		}
	});

	// Show the default red marker at the location
	let marker = new google.maps.Marker({
		position: latLngCenter,
		map: map,
		draggable: false,
		title: address,
	});
}

function googleMapCalculateDimensions(map) {
	const bounds = map.getBounds();
	const ne = bounds.getNorthEast();
	const sw = bounds.getSouthWest();
	const height = ne.lat() - sw.lat();
	const width = ne.lng() - sw.lng();
	return {height, width};
}

/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @param object block The block html element.
 *
 * @return  void
 */
export function initializeBlock( block ) {
	const mapContainer = block.querySelector('.wp-block-aptum-contact-info__map');

	const init = () => {
		renderMap(mapContainer);
	}

	if (window.google && window.google.maps) {
		init();
	} else {
		window.addEventListener('GoogleMapsLoaded', init);
	}
}

export const blockName = 'contact-info';
